import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Stylized compass rose — replaces Globe for language switcher */
export function IconCompass({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9.5" />
      {/* Compass diamond */}
      <polygon points="12,5 14.5,12 12,19 9.5,12" fill="currentColor" opacity="0.2" stroke="none" />
      <polygon points="5,12 12,9.5 19,12 12,14.5" fill="currentColor" opacity="0.2" stroke="none" />
      {/* Center dot */}
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
      {/* Cardinal ticks */}
      <line x1="12" y1="2" x2="12" y2="4" />
      <line x1="12" y1="20" x2="12" y2="22" />
      <line x1="2" y1="12" x2="4" y2="12" />
      <line x1="20" y1="12" x2="22" y2="12" />
    </svg>
  );
}
